import { useTranslation } from 'react-i18next';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { useEffect, useState } from 'react';
import classNames from 'classnames';
import IconMove from './Dnd/iconMove';
import { STATE } from './STATE';
import { Form, Input, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import TrrSelectCustom from './TreeSelectCustom';
import moment from 'moment';
import ModalDelete from '../../../components/Shared/modal/delete';
import PropTypes from 'prop-types';

const WorkflowStep = ({
    form,
    workflow,
    disabled,
    state,
    department,
    errorStep,
    setErrorStep,
}) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState();

    const workflowStep = Form.useWatch('workflowStep', form);

    useEffect(() => {
        if (workflow) {
            setSelected(workflow?.workflowStep[0]);
        }
    }, [workflow]);

    useEffect(() => {
        if (errorStep) {
            setSelected(workflowStep[Number(errorStep)]);
            setErrorStep();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorStep, workflowStep]);

    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        if (
            result.destination.index === 0 ||
            result.destination.index === workflowStep?.length - 1
        ) {
            return;
        }

        const newItems = reorder(
            workflowStep,
            result.source.index,
            result.destination.index
        );

        form.setFieldsValue({
            workflowStep: newItems,
        });
    };

    const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index),
    ];

    const isDragDisabled = (item) =>
        item.stateId === STATE.VERIFICATION ||
        item.stateId === STATE.COMPLETE_TASK ||
        item.stateId === STATE.CANCEL_TASK;

    return (
        <div className="pb-12">
            <div className="font-medium text-xl">{t('Workflow Step')}</div>
            <div className="text-sm text-gray-400">
                {t('sequence of work steps')}
            </div>
            <div className="flex space-x-4 mt-4">
                <div className="space-y-2">
                    {workflowStep?.map((item, index) => (
                        <div className="flex space-x-2" key={item.stepId}>
                            <div className="text-purple bg-[#F4F6FC] text-[28px] rounded-full h-10 w-10 flex items-center justify-center">
                                {index + 1}
                            </div>
                        </div>
                    ))}
                </div>
                <Form.List name="workflowStep">
                    {(fields, { add, remove }) => (
                        <>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            {workflowStep?.map(
                                                (item, index) => (
                                                    <Draggable
                                                        key={item.stepId}
                                                        draggableId={
                                                            item.stepId
                                                        }
                                                        index={index}
                                                        isDragDisabled={
                                                            isDragDisabled(
                                                                item
                                                            ) || disabled
                                                        }
                                                    >
                                                        {(provided) => (
                                                            <button
                                                                type="button"
                                                                ref={
                                                                    provided.innerRef
                                                                }
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={classNames(
                                                                    'rounded-md flex items-center p-4 mb-2 h-10 w-56 text-sm font-medium cursor-default pl-14 relative',
                                                                    {
                                                                        'bg-[#F4F6FC] text-purple ':
                                                                            item.stepId !==
                                                                            selected?.stepId,
                                                                        'bg-purple text-white ':
                                                                            item.stepId ===
                                                                            selected?.stepId,
                                                                    }
                                                                )}
                                                                onClick={() =>
                                                                    setSelected(
                                                                        item
                                                                    )
                                                                }
                                                            >
                                                                <div
                                                                    className="absolute left-5 top-2"
                                                                    hidden={
                                                                        isDragDisabled(
                                                                            item
                                                                        ) ||
                                                                        disabled
                                                                    }
                                                                >
                                                                    <IconMove />
                                                                </div>

                                                                <span>
                                                                    {
                                                                        item.stepName
                                                                    }
                                                                </span>
                                                            </button>
                                                        )}
                                                    </Draggable>
                                                )
                                            )}
                                            {provided.placeholder}
                                            <button
                                                type="button"
                                                hidden={
                                                    disabled ||
                                                    workflowStep?.length === 10
                                                }
                                                onClick={() => {
                                                    const newItem = {
                                                        stepName: 'New Step',
                                                        stepId: moment()
                                                            .valueOf()
                                                            .toString(),
                                                        stateId:
                                                            STATE.OTHER_TASK,
                                                        isCreateBySystem: false,
                                                        assignTo: [],
                                                        isNewStep: true,
                                                    };
                                                    let temp = [
                                                        ...workflowStep,
                                                    ];
                                                    let _workflowStep = insert(
                                                        temp,
                                                        workflowStep.length - 1,
                                                        newItem
                                                    );
                                                    form.setFieldsValue({
                                                        workflowStep:
                                                            _workflowStep,
                                                    });
                                                    setSelected(newItem);
                                                }}
                                                style={{
                                                    border: '1px dashed #7B67FB',
                                                }}
                                                className="bg-[#F4F6FC] w-full rounded-md text-purple flex items-center p-4 mb-2 h-10 text-sm font-medium space-x-2 cursor-pointer"
                                            >
                                                <PlusOutlined />
                                                <span>{t('Add Step')}</span>
                                            </button>
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            <div className="w-full ml-4">
                                {workflowStep?.map((item, i) => (
                                    <div
                                        hidden={
                                            item.stepId !== selected?.stepId
                                        }
                                        key={i}
                                        className="p-4 rounded-md"
                                        style={{
                                            border: '1px solid #7B67FB',
                                            boxShadow:
                                                '0px 2px 12px rgba(123, 103, 251, 0.2)',
                                        }}
                                    >
                                        {!disabled && (
                                            <DeleteComponent
                                                item={item}
                                                remove={remove}
                                                i={i}
                                                onSelect={() => {
                                                    setSelected(
                                                        workflowStep[i - 1]
                                                    );
                                                }}
                                            />
                                        )}
                                        <Form.Item
                                            className="mb-2 w-full"
                                            isListField
                                            name={[i, 'stepName']}
                                            label={t('Step Name')}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                disabled={disabled}
                                                placeholder={t(
                                                    'dataFlow.inputpl'
                                                )}
                                                maxLength={20}
                                                showCount
                                                size="large"
                                                className="pr-12"
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('State')}
                                            className="mb-2 w-full"
                                            isListField
                                            name={[i, 'stateId']}
                                        >
                                            <Select
                                                placeholder={t('Select State')}
                                                style={{ width: '100%' }}
                                                size="large"
                                                disabled
                                            >
                                                {state?.map((state) => (
                                                    <Select.Option
                                                        key={state?.stateId}
                                                        value={state?.stateId}
                                                    >
                                                        {state?.stateName}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label={t('Step Description')}
                                            className="mb-2 w-full"
                                            isListField
                                            name={[i, 'stepDescription']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input.TextArea
                                                disabled={disabled}
                                                placeholder={t(
                                                    'dataFlow.inputpl'
                                                )}
                                                rows={4}
                                                size="large"
                                                className="pr-12"
                                            />
                                        </Form.Item>
                                        {item.stateId ===
                                            STATE.VERIFICATION && (
                                            <Form.Item
                                                label={t('Assign to')}
                                                className="mb-2 w-full"
                                                isListField
                                                name={[i, 'assignTo']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t(
                                                            'errorText.requiredField'
                                                        ),
                                                    },
                                                ]}
                                            >
                                                <TrrSelectCustom
                                                    disabled={disabled}
                                                    department={department}
                                                />
                                            </Form.Item>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </Form.List>
            </div>
        </div>
    );
};

const DeleteComponent = ({ remove, item, i, onSelect }) => {
    const [openDelete, setOpenDelete] = useState(false);
    return (
        <div className="w-full flex justify-end">
            <button
                type="button"
                hidden={item.isCreateBySystem}
                className="cursor-pointer w-max"
                onClick={() => {
                    setOpenDelete(true);
                }}
            >
                {DeleteIcon}
            </button>
            <ModalDelete
                open={openDelete}
                handelOk={() => {
                    remove(i);
                    setOpenDelete(false);
                    onSelect();
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </div>
    );
};

const DeleteIcon = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#F3F6F9" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);

DeleteComponent.propTypes = {
    remove: PropTypes.func,
    item: PropTypes.object,
    i: PropTypes.number,
    onSelect: PropTypes.func,
};

WorkflowStep.propTypes = {
    form: PropTypes.object,
    workflow: PropTypes.object,
    disabled: PropTypes.bool,
    state: PropTypes.array,
    department: PropTypes.array,
    errorStep: PropTypes.string,
    setErrorStep: PropTypes.func,
};

export default WorkflowStep;
